/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  BodyAnalyzeContractContractReviewAnalyzePost,
  BodyUploadAndAnalyzeContractContractReviewUploadAnalyzePost,
  HTTPValidationError,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class ContractReview<
  SecurityDataType = unknown
> extends HttpClient<SecurityDataType> {
  /**
   * @description Process uploaded PDF contract and extract data using PyMuPDF.
   *
   * @tags contracts
   * @name AnalyzeContractContractReviewAnalyzePost
   * @summary Analyze Contract
   * @request POST:/contract-review/analyze
   */
  analyzeContractContractReviewAnalyzePost = (
    data: BodyAnalyzeContractContractReviewAnalyzePost,
    params: RequestParams = {}
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/contract-review/analyze`,
      method: "POST",
      body: data,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description Manually trigger cleanup of old files.
   *
   * @tags contracts
   * @name CleanupFilesContractReviewCleanupPost
   * @summary Cleanup Files
   * @request POST:/contract-review/cleanup
   */
  cleanupFilesContractReviewCleanupPost = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/contract-review/cleanup`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Upload and analyze a contract document
   *
   * @tags contracts
   * @name UploadAndAnalyzeContractContractReviewUploadAnalyzePost
   * @summary Upload And Analyze Contract
   * @request POST:/contract-review/upload-analyze
   */
  uploadAndAnalyzeContractContractReviewUploadAnalyzePost = (
    data: BodyUploadAndAnalyzeContractContractReviewUploadAnalyzePost,
    params: RequestParams = {}
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/contract-review/analyze`,
      method: "POST",
      body: data,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
}
